/**
 * Supabase client. Copied from `bimgo-ai-web/client/src/lib/supabaseClient.ts`,
 * with the config moved behind `./config` so an unconfigured build fails with a
 * sentence rather than a network error.
 *
 * `persistSession` is what makes "quit and relaunch — still logged in" work: the
 * session lives in `localStorage`, scoped to the origin. That is ordinary for a
 * hosted `https://` origin — it was the open question only while the plan was a
 * bundled `app://` renderer (Corrections #10).
 *
 * Created lazily so importing this module in an unconfigured build does not
 * throw at module load — the same trap the 2.x agent's `config.ts` sets, where a
 * top-level initializer kills the process before the logger starts.
 */
import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { SUPABASE_ANON_KEY, SUPABASE_URL } from "./config";
import { authFetch } from "./authSession";

let client: SupabaseClient | null = null;

export function supabase(): SupabaseClient {
  if (!client) {
    client = createClient(SUPABASE_URL(), SUPABASE_ANON_KEY(), {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
      global: {
        // Through a closure, not passed directly: authSession imports `supabase`
        // back from this module, so the binding must resolve when a request is
        // made, not while this module is still evaluating (mirrors bimgo-ai-web).
        fetch: (input, init) => authFetch(input, init),
      },
    });
  }
  return client;
}
